/**
 * NOTE This function needs moment to support ISO formatted timestamps
 * with IE11. When IE11 support stops, this dependency should be safe to remove.
 */
import moment from 'moment';

/**
 * Formats the given ISO string to MM/DD/YYYY.
 * @param {string} isoString - An ISO formatted date string
 */
const formatDate = (isoString = '') => {
  const d = moment(isoString);
  return `${d.month() + 1}/${d.date()}/${d.year()}`;
};

export default formatDate;
